import { readAppEnv } from "@how/app-kit";

/** Validated build-time configuration. Only publishable values may ever appear here. */
export const env = readAppEnv(import.meta.env);
